import React, { useState } from 'react';
import Icon from 'components/AppIcon';

const BulkActionsToolbar = ({ selectedCount, onBulkTerminate, onClearSelection }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [actionType, setActionType] = useState('');

  const handleBulkAction = (action) => {
    setActionType(action);
    setShowConfirmDialog(true);
  };

  const confirmAction = () => {
    if (actionType === 'terminate') {
      onBulkTerminate();
    }
    setShowConfirmDialog(false);
    setActionType('');
  };

  const cancelAction = () => {
    setShowConfirmDialog(false);
    setActionType('');
  };

  return (
    <>
      <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Icon name="CheckSquare" size={20} className="text-primary" />
              <span className="font-medium text-text-primary">
                Выбрано сессий: {selectedCount}
              </span>
            </div>
            <button
              onClick={onClearSelection}
              className="text-sm text-primary hover:text-primary-700 transition-colors duration-150"
            >
              Снять выделение
            </button>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => handleBulkAction('alert')}
              className="
                flex items-center gap-2 px-4 py-2 bg-warning text-white rounded-md
                hover:bg-warning-600 transition-colors duration-150 hover-lift
              "
            >
              <Icon name="AlertTriangle" size={16} />
              Отправить предупреждения
            </button>

            <button
              onClick={() => handleBulkAction('export')}
              className="
                flex items-center gap-2 px-4 py-2 bg-accent text-white rounded-md
                hover:bg-accent-700 transition-colors duration-150 hover-lift
              "
            >
              <Icon name="Download" size={16} />
              Экспорт данных
            </button>

            <button
              onClick={() => handleBulkAction('terminate')}
              className="
                flex items-center gap-2 px-4 py-2 bg-error text-white rounded-md
                hover:bg-error-600 transition-colors duration-150 hover-lift
              "
            >
              <Icon name="X" size={16} />
              Завершить сессии
            </button>

            <button
              onClick={() => handleBulkAction('system-logout')}
              className="
                flex items-center gap-2 px-4 py-2 bg-error-700 text-white rounded-md
                hover:bg-error-800 transition-colors duration-150 hover-lift
              "
            >
              <Icon name="LogOut" size={16} />
              Системный выход
            </button>
          </div>
        </div>
      </div>

      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-modal p-4">
          <div className="bg-surface rounded-lg shadow-xl border border-secondary-200 w-full max-w-md">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className={`
                  w-12 h-12 rounded-full flex items-center justify-center
                  ${actionType === 'terminate' || actionType === 'system-logout' ?'bg-error-100' 
                    : actionType === 'alert' ?'bg-warning-100' :'bg-accent-100'
                  }
                `}>
                  <Icon 
                    name={
                      actionType === 'terminate' ? 'X' :
                      actionType === 'system-logout' ? 'LogOut' :
                      actionType === 'alert' ? 'AlertTriangle' : 'Download'
                    } 
                    size={24} 
                    className={
                      actionType === 'terminate' || actionType === 'system-logout' ?'text-error-600' 
                        : actionType === 'alert' ?'text-warning-600' :'text-accent-600'
                    }
                  />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-text-primary">
                    {actionType === 'terminate' && 'Завершить выбранные сессии?'}
                    {actionType === 'system-logout' && 'Системный выход из всех сессий?'}
                    {actionType === 'alert' && 'Отправить предупреждения?'}
                    {actionType === 'export' && 'Экспорт данных сессий?'}
                  </h3>
                  <p className="text-text-secondary mt-1">
                    {actionType === 'terminate' && `Это действие завершит ${selectedCount} выбранных сессий. Пользователи будут отключены от системы.`}
                    {actionType === 'system-logout' && `Это действие принудительно завершит ${selectedCount} сессий и выполнит системный выход для всех пользователей.`}
                    {actionType === 'alert' && `Будут отправлены предупреждения пользователям ${selectedCount} выбранных сессий.`}
                    {actionType === 'export' && `Будут экспортированы данные ${selectedCount} выбранных сессий в CSV формате.`}
                  </p>
                </div>
              </div>

              {(actionType === 'terminate' || actionType === 'system-logout') && (
                <div className="bg-error-50 border border-error-200 rounded-lg p-3 mb-4">
                  <div className="flex items-start gap-2">
                    <Icon name="AlertTriangle" size={16} className="text-error-600 mt-0.5" />
                    <div>
                      <p className="text-sm font-medium text-error-800">Внимание!</p>
                      <p className="text-sm text-error-700">
                        Это действие нельзя отменить. Пользователи потеряют доступ к системе и должны будут войти заново.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex items-center justify-end gap-3">
                <button
                  onClick={cancelAction}
                  className="px-4 py-2 border border-secondary-300 text-text-primary rounded-md hover:bg-secondary-50 transition-colors duration-150"
                >
                  Отмена
                </button>
                <button
                  onClick={confirmAction}
                  className={`
                    px-4 py-2 text-white rounded-md transition-colors duration-150
                    ${actionType === 'terminate' || actionType === 'system-logout' ?'bg-error hover:bg-error-600'
                      : actionType === 'alert' ?'bg-warning hover:bg-warning-600' :'bg-accent hover:bg-accent-700'
                    }
                  `}
                >
                  {actionType === 'terminate' && 'Завершить сессии'}
                  {actionType === 'system-logout' && 'Выполнить системный выход'}
                  {actionType === 'alert' && 'Отправить предупреждения'}
                  {actionType === 'export' && 'Экспорт данных'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActionsToolbar;